export const FREE_FOR_NOW = 'chapter_free_for_now';					// 무료
export const UNLOCK_COINBACK = 'chapter_unlock_coinback';		// 코인백
export const UNLOCK_DISCOUNT = 'chapter_unlock_discount';		// 할인

export const TYPE_PROMOTION = {
	FREE_FOR_NOW,
	UNLOCK_COINBACK,
	UNLOCK_DISCOUNT
};